import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { useThemeSettings } from '@webbyx/mui';
import { ApexOptions } from 'apexcharts';

import { Money } from '../../index';
import { ChartProps } from '../props';
import ReactApexcharts from '../react-apexchart';

export const PieChart: React.FC<ChartProps> = (props) => {
  const { colors, data, isMoney = false } = props;
  const { settings } = useThemeSettings();

  const options: ApexOptions = {
    chart: {
      background: 'transparent !important',
    },
    theme: {
      mode: settings.mode === 'semi-dark' ? 'light' : settings.mode,
    },
    stroke: { width: 0 },
    labels: data?.labels ?? [],
    colors: colors,
    dataLabels: {
      enabled: false,
      formatter: (val: string) => `${parseInt(val, 10)}%`,
    },
    tooltip: {
      y: {
        formatter(val: number, opts?: any): string {
          if (isMoney) {
            return ReactDOMServer.renderToString(
              <Money amount={val} currency={'RM'} />
            );
          }
          return val.toString();
        },
      },
    },
    legend: {
      show: false,
    },
  };

  return (
    <ReactApexcharts
      type="pie"
      height={'auto'}
      options={options}
      series={data?.series ?? []}
    />
  );
};

export default PieChart;
